import { render, staticRenderFns } from "./CommentTemplate.vue?vue&type=template&id=6d97928c&scoped=true"
import script from "./CommentTemplate.vue?vue&type=script&lang=js"
export * from "./CommentTemplate.vue?vue&type=script&lang=js"
import style0 from "./CommentTemplate.vue?vue&type=style&index=0&id=6d97928c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97928c",
  null
  
)

export default component.exports